<template>
  <!-- <NuxtRouteAnnouncer /> -->
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>

  <Teleport to="body">
    <ModalsContainer />
  </Teleport>
</template>

<style lang="scss">
  @import "assets/scss/main.scss";
  @import "vue-final-modal/style.css";
</style>

<script setup lang="ts">
import sniffBrowser from "./lib/sniff-browser";
import "virtual:svg-icons-register";
import "core-js/proposals/array-grouping-v2";
import { ModalsContainer } from "vue-final-modal";

if (import.meta.client) {
  (window as any).browser = sniffBrowser();
}

useHead({
  titleTemplate: (titleChunk) =>
    titleChunk ? `${titleChunk} | House of Lobkowicz` : "House of Lobkowicz",
});
</script>
